import { render, staticRenderFns } from "./PatientFeedback.vue?vue&type=template&id=e868aa44"
import script from "./PatientFeedback.vue?vue&type=script&lang=js"
export * from "./PatientFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports